/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.jQuery = require('jquery');
window.$ = window.jQuery;

import "../../../../node_modules/slick-carousel/slick/slick";
window.Swiper = require('swiper/swiper-bundle');

import "./custom";
import Vue from "vue";

window.Vue = Vue;

import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require("./components");
require("./pages");

import store from "./store";
import router from "./router";

// store.dispatch('init');
// store.dispatch('cart/init');

const app = new Vue({
  el: "#app",
  store,
  router
});
